export const statusColor = (status) => {
	if (['details_updated', 'validated', 'in_progress'].includes(status)) return 'orange'
	if (['approved'].includes(status)) return 'green'
	if (['rejected', 'cancelled'].includes(status)) return 'red'
	return 'gray'
}
